import { useEffect, useState } from "react";
import { FiFileText, FiTrash2, FiUpload } from "react-icons/fi";

export const FileUpload = ({ file, onChange, fileTypes = ".pdf,.jpg,.jpeg,.png", tag = "PDF, PNG, JPG" }) => {
    const [isImage, setIsImage] = useState(false);

    useEffect(() => {
        if (typeof file !== "string") return;
        
        const img = new Image();
        img.src = file;
        img.onload = () => setIsImage(true);
        img.onerror = () => setIsImage(false);
    }, [file]);

    return (
        <div className="relative mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md hover:border-gray-400 transition-colors">
            {
                file ?
                    <>
                        {
                            typeof file === "string" ?
                                isImage ?
                                <img src={file} alt="file" className="w-full h-full object-cover" />
                                :
                                <a target="_blank" rel="noopener noreferrer" href={file} >
                                    <div className="w-full h-full flex flex-row gap-4 items-center justify-center border-2 border-gray-300 p-4 rounded-xl">
                                        <FiFileText className="inline h-10 w-10 mr-1" />
                                        <p className="text-sm text-gray-800">
                                            {file}
                                        </p>
                                    </div>
                                </a>
                                :
                                file.type.startsWith("image/") ?
                                <img src={URL.createObjectURL(file)} alt="file" className="w-full h-full object-cover" />
                                :
                                <a target="_blank" rel="noopener noreferrer" href={file} >
                                    <div className="w-full h-full flex flex-row gap-4 items-center justify-center border-2 border-gray-300 p-4 rounded-xl">
                                        <FiFileText className="inline h-10 w-10 mr-1" />
                                        <p className="text-sm text-gray-800">
                                            {file.name}
                                        </p>
                                    </div>
                                </a>
                        }

                        <div className="bg-brand-primary rounded-xl absolute top-3 right-3 justify-center items-center p-3">
                            <FiTrash2 className="text-white w-5 h-5 cursor-pointer" onClick={(e) => { e.stopPropagation(); onChange({ target: { files: [] } }) }} />
                        </div>
                    </>
                    :
                    <div className="space-y-1 text-center">
                        <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
                        <div className="flex text-sm text-gray-600">
                            <label
                                htmlFor="file"
                                className="relative cursor-pointer bg-white rounded-md font-medium text-primary-600 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                            >
                                <span>Upload a file</span>
                                <input
                                    id="file"
                                    name="file"
                                    type="file"
                                    accept={fileTypes}
                                    onChange={onChange}
                                    className="sr-only"
                                />
                            </label>
                            <p className="pl-1">or drag and drop</p>
                        </div>
                        <p className="text-xs text-gray-500">
                            {tag} up to 10MB
                        </p>
                        {file && (
                            <p className="text-sm text-green-600 font-medium">
                                Selected: {file.name}
                            </p>
                        )}
                    </div>
            }
        </div>
    );
};